"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
function useBulkAction(_a) {
    var rowsId = _a.rowsId, selectedRowsId = _a.selectedRowsId, setSelectedRowsId = _a.setSelectedRowsId, placeholder = _a.placeholder, getLabel = _a.getLabel, options = _a.options, onSelectAction = _a.onSelectAction;
    var handleSelectAll = function (all) {
        if (all) {
            setSelectedRowsId(__spreadArrays(rowsId));
        }
        if (!all) {
            setSelectedRowsId([]);
        }
    };
    var handleOnSelectRow = function (id) {
        if (selectedRowsId.includes(id)) {
            var newSelectedRows = selectedRowsId.filter(function (rowId) { return rowId !== id; });
            setSelectedRowsId(newSelectedRows);
            return;
        }
        setSelectedRowsId(__spreadArrays(selectedRowsId, [id]));
    };
    var checkedLength = selectedRowsId.length;
    var trueOrIndeterminate = checkedLength === rowsId.length ? true : "indeterminate";
    var checked = checkedLength === 0 ? false : trueOrIndeterminate;
    var bulkAction = {
        checked: checked,
        placeholder: placeholder,
        getLabel: getLabel,
        onSelectAll: handleSelectAll,
        options: options,
        onSelectAction: onSelectAction,
    };
    return { bulkAction: bulkAction, handleOnSelectRow: handleOnSelectRow };
}
exports.default = useBulkAction;
//# sourceMappingURL=useBulkAction.js.map